// NotFound.js
import React from "react";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <div className="relative h-screen bg-cover bg-center" style={{ backgroundImage: `url('/images/home.jpg')` }}>
      <div className="flex items-center justify-center h-full bg-black bg-opacity-50">
        <div className="text-center text-white">
          <h1 className="text-6xl font-bold mb-4">404</h1>
          <p className="text-2xl mb-8">Oops! On dirait que cette page a décidé de prendre un jour de congé.</p>
          <p className="text-2xl mb-8">Mais ne vous inquiétez pas, notre site est encore debout !</p>
          <Link to="/">
            <button className="mt-4 px-6 py-3 bg-blue-500 text-white text-xl font-semibold rounded-md shadow-md hover:bg-blue-600 transition duration-300">
              Retourner à la page d'accueil
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
